import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import { WebAPIProvider } from './contexts/WebAPIContext';
import App from './pages/App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './utils/i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = extendTheme({
  components: {
    Modal: {
      baseStyle: {
        overlay: {
          bg: "blackAlpha.300",
          backdropFilter: 'blur(10px) hue-rotate(90deg)'
        },
      },
    },
    Drawer: {
      baseStyle: {
        overlay: {
          bg: "blackAlpha.300",
          backdropFilter: 'blur(10px) hue-rotate(90deg)'
        },
      },
    }
  },
});

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ChakraProvider theme={theme} toastOptions={{ defaultOptions: { containerStyle: { whiteSpace: 'pre-wrap' } } }}>
        <BrowserRouter>
          <ErrorBoundary>
            <WebAPIProvider>
              <App />
            </WebAPIProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </ChakraProvider>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
